import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    redRadioIcon: {
        '& .MuiSvgIcon-root': {
            color: theme.palette.error.main,
        },
        '& .MuiSvgIcon-root > path': {
            color: theme.palette.error.main,
        },
    },
}));
export const RadioField = ({ options, defaultValue, id, label, layout = 'vertical', className, onChange, error, }) => {
    const classes = useStyles();
    return (<FormControl error={error} style={layout === 'horizontal' ? {
            width: '100%',
        } : {}}>
			{label ? <FormLabel id={id}>{label}</FormLabel> : null}
			<RadioGroup aria-labelledby={id} defaultValue={defaultValue} name={id} style={{
            flexDirection: layout === 'horizontal'
                ? 'row'
                : layout === 'vertical'
                    ? 'column' : undefined,
            gap: '0.5rem',
        }} className={className}>
				{options.map(option => (<FormControlLabel key={option.label} value={option.value} control={(<Radio style={{
                    padding: 0,
                }} className={error ? classes.redRadioIcon : ''}/>)} onClick={() => onChange(option.value)} label={(<span style={{
                    fontSize: 14,
                    color: error ? '#f44336' : undefined,
                }}>{option.label}
							</span>)} style={Object.assign(Object.assign({}, (layout === 'horizontal' ? {
                flexDirection: 'column',
                marginLeft: 0,
                marginRight: 0,
                gap: 1,
            } : layout === 'vertical' ? {
                flexDirection: 'row',
                marginLeft: -1,
                marginRight: 0,
                gap: '0.5rem',
            } : {})), { fontSize: 14 })}/>))}
			</RadioGroup>
		</FormControl>);
};
